
import React from 'react';
import { jobVacancies } from '@/data/jobVacancies';
import JobVacancyCard from './JobVacancyCard';

const JobVacancies = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Onze vacatures
            </h2>
            <p className="text-xl text-gray-600">
              Ontdek de beschikbare posities en word onderdeel van ons team
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 items-stretch">
            {jobVacancies.map((vacancy) => (
              <JobVacancyCard 
                key={vacancy.id} 
                vacancy={vacancy}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobVacancies;
